<script >
import CollapseTransition from './CollapseTransition/index.vue';
import Icon from './icon.vue';
import useFold from './useFold';
const __sfc_main = {};
__sfc_main.props = {
  theme: {
    type: String
  },
  isFold: {
    type: Boolean,
    default: false
  },
  iconColor: {
    type: String,
    default: '#FF6900'
  },
  list: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useLang,
    usePageType,
    useDark
  } = require('@fegobull/webapi').use;
  const {
    langText
  } = useLang();
  const {
    isPC
  } = usePageType();
  const props = __props;
  /* 折叠 */
  const {
    contentCanFold,
    handleShowContent,
    displayContent
  } = useFold(props);

  /* 黑白肤 */
  const {
    isAuto: isSkinAuto,
    isDark: isSkinDark
  } = useDark?.(props.theme === 'dark') || {
    isDark: props.theme === 'dark'
  };
  return {
    langText,
    isPC,
    contentCanFold,
    handleShowContent,
    displayContent,
    isSkinAuto,
    isSkinDark
  };
};
__sfc_main.components = Object.assign({
  Icon,
  CollapseTransition
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <div
        :class="[
            'basic-faq-container',
            langText,
            {
                'client-skin-adapt': isSkinAuto,
                dark: isSkinDark,
                pc: isPC
            }
        ]"
    >
        <ul class="faq-list">
            <li v-for="(item, index) in list" :key="index" class="faq-item" :data-active="item.isExpand">
                <a href="javascript:;" class="heading" @click="handleShowContent(item)">
                    <p v-html="item.question"></p>
                    <icon :isActive="item.isExpand" :theme="isSkinDark && 'dark'" :activeColor="iconColor"></icon>
                </a>
                <collapse-transition v-if="contentCanFold">
                    <div v-show="displayContent(item)" class="content" v-html="item.answer"></div>
                </collapse-transition>
            </li>
        </ul>
    </div>
</template>
<style lang="less" scoped>
@import './index.less';
</style>
